import React from "react";

export const Institution = () => {
	return (
		<svg viewBox="0 0 90 76" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M24.6511 31.2168H14.4771V61.7398H24.6511V31.2168Z" fill="#D8D8D8" />
			<path d="M41.6081 31.2168H31.4341V61.7398H41.6081V31.2168Z" fill="#D8D8D8" />
			<path d="M58.5671 31.2168H48.3921V61.7398H58.5671V31.2168Z" fill="#D8D8D8" />
			<path d="M75.524 31.2168H65.349V61.7398H75.524V31.2168Z" fill="#D8D8D8" />
			<path d="M82.306 65.1318H7.69299V68.5238H82.306V65.1318Z" fill="#D8D8D8" />
			<path d="M89.09 71.915H0.910034V75.307H89.09V71.915Z" fill="#D8D8D8" />
			<path d="M48.392 0.692871H45H41.608L4.302 24.4339V27.8259H85.698V24.4339L48.392 0.692871Z" fill="#D8D8D8" />
		</svg>
	);
};
